module.exports = __webpack_public_path__ + "img/_ireland.0dcabb25.png";